export type ExternalFilters = Record<string, any>;
